/* eslint-disable no-underscore-dangle, max-lines-per-function */
import { api } from "jiffy-api";
import { store } from "jiffy-store";
import { formatQuantity } from "common/utils/form/collect-form-items-qty";

const REGEXP = {
  FAILED_TO_FETCH: /Failed to fetch/,
  LOAD_FAILED: /Load failed/,
  BAD_GATEWAY: /Bad Gateway/,
  THROTTLED: /Application request limit reached/
};
const isNetworkError = error =>
  REGEXP.FAILED_TO_FETCH.test(error.stack) || REGEXP.LOAD_FAILED.test(error.message);
const isBadGateway = error =>
  REGEXP.BAD_GATEWAY.test(error.stack) || REGEXP.BAD_GATEWAY.test(error.message);
const isRequestThrottled = error =>
  REGEXP.THROTTLED.test(error.stack) || REGEXP.THROTTLED.test(error.message);
const fetchSimilarItemsButton = () => {
  const $similarItemButtonPlaceholders = document.querySelectorAll(
    ".js-similar-items-button-placeholder"
  );
  if ($similarItemButtonPlaceholders.length > 0) {
    const { compositionName, realProductId } =
      document.getElementById("product-page-container").dataset;
    api.product
      .fetchSimilarItemsButtonHtml(
        { productId: realProductId },
        { ac: compositionName },
        { cacheable: true }
      )
      .then(({ html }) => {
        if (html) {
          $similarItemButtonPlaceholders.forEach($placeholder => {
            if ($placeholder.parentNode && $placeholder.outerHTML) {
              $placeholder.outerHTML = html;
            }
          });
        }
      })
      .catch(error => {
        if (isNetworkError(error)) return;
        if (isBadGateway(error)) return;
        if (isRequestThrottled(error)) return;

        window.Honeybadger?.notify("Error fetching similar items button", {
          fingerprint: `fetching similar items button: ${error.message || error.stack || ""}`,
          params: {
            error: JSON.stringify(error, Object.getOwnPropertyNames(error)),
            product_id: realProductId,
            composition_name: compositionName
          }
        });
      });
  }
};

const oosPrices = {
  rowItemClassName: ".js-quantity-form-row-hidden-amounts",
  _getRowItems() {
    return document.querySelectorAll(this.rowItemClassName);
  },
  _increase($input, attribute) {
    const $rowItem = $input.closest(this.rowItemClassName);
    if ($rowItem) {
      const oosCount = parseInt($rowItem.getAttribute(attribute), 10) || 0;
      $rowItem.setAttribute(attribute, `${oosCount + 1}`);
    }
  },
  clearAll() {
    const $rowItems = this._getRowItems();

    $rowItems.forEach($rowItem => {
      $rowItem.removeAttribute("oos-count");
      $rowItem.removeAttribute("all-count");
    });
  },
  increaseOOS($input) {
    this._increase($input, "oos-count");
  },
  increaseAll($input) {
    this._increase($input, "all-count");
  },
  setClasses(activeColor) {
    const $dtfForm = document.querySelector(".js-dtf-size-selector");
    if ($dtfForm) return;

    const $rowItems = this._getRowItems();
    const $dateText = document.querySelector(".js-pdp-restock-date-text");
    let hasOosRowItems = false;

    $rowItems.forEach($rowItem => {
      const oosCount = $rowItem.getAttribute("oos-count");
      const allCount = $rowItem.getAttribute("all-count");

      if (oosCount === allCount) {
        $rowItem.classList.add("hide-amounts");
      }
      if (oosCount > 0) {
        $rowItem.classList.add("has-oos");
        if (activeColor === $rowItem.dataset.activeColor) {
          hasOosRowItems = true;
        }
      }
    });

    $dateText?.classList.toggle("has-oos", hasOosRowItems);

    if (hasOosRowItems) fetchSimilarItemsButton();
  }
};

const setMobileGridAttrsNewLayout = (input, quantity) => {
  const $parent = input.closest(".js-qty-form-group");
  const outOfStock = quantity <= 0;
  const isAbQtyGridMadePdp = Boolean(document.querySelector(".ab_qty_grid_made_pdp_v3"));
  const $node = $parent?.querySelector(".js-stock-amount");
  if (!$node) return;

  input.setAttribute("max", quantity);

  if (outOfStock) {
    input.setAttribute("disabled", "disabled");

    $node.innerHTML = isAbQtyGridMadePdp ? "Out of Stock" : "Out";
    $node.classList.add("product-details-quantity-form-row__stock-amount--out");

    if (isAbQtyGridMadePdp) {
      $node.previousElementSibling.classList.add("hidden");

      const parentSiblings = Array.from($node.parentNode.parentNode.children).filter(
        child => child !== $node.parentNode
      );
      parentSiblings.forEach(sibling => {
        sibling.classList.add("product-details-quantity-form-row__oos-opacity");
      });
    }

    oosPrices.increaseOOS(input);
  } else {
    input.removeAttribute("disabled");
    $node.innerHTML = formatQuantity(quantity);
    $node.classList.remove("product-details-quantity-form-row__stock-amount--out");
  }
  oosPrices.increaseAll(input);
};

const initFieldsOnGrids = activeColor => {
  const { inventory: variantCounts = {} } = window;

  const $inputs = document.querySelectorAll(
    "#product-details-quantity-form input[data-variant-id]"
  );

  oosPrices.clearAll();
  $inputs.forEach(input => {
    const { variantId } = input.dataset;
    const quantity = variantCounts[variantId] || 0;

    setMobileGridAttrsNewLayout(input, quantity);
  });
  oosPrices.setClasses(activeColor);
};

const setFieldsOnGrids = () => {
  store.pdp.changed(({ pdp }, { data }) => {
    if (!data.isSettingGridInventory || pdp.isFlashPdpLoading) return;
    initFieldsOnGrids(data.activeColor);
    store.pdp.change({ isSettingGridInventory: false });
  });
};

export default setFieldsOnGrids;
